/* import __COLOCATED_TEMPLATE__ from './market-date-select.hbs.js'; */
var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
let MarketDateSelect = (_class = class MarketDateSelect extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "localeTime", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    _initializerDefineProperty(this, "marketDropdown", _descriptor3, this);
  }
  get selectionType() {
    return this.args.selectionType || 'single';
  }
  get startDateString() {
    const d = this.args.startDate;
    return d ? d.toISOString() : null;
  }
  get endDateString() {
    const d = this.args.endDate;
    return d && this.selectionType === 'range' ? d.toISOString() : null;
  }
  get displayDate() {
    const {
      startDate,
      endDate
    } = this.args;
    if (!startDate) {
      return '';
    }
    const formattedStartDate = this.intl.formatDate(startDate);
    if (!endDate || this.selectionType === 'single') {
      return formattedStartDate;
    }
    const formattedEndDate = this.intl.formatDate(new Date(endDate));
    return this.intl.t('sharedUi.dateSelect.rangeFormat', {
      start: formattedStartDate,
      end: formattedEndDate
    });
  }

  // Store market-dropdown element, so we can manually close it when needed.
  marketDropdownInserted(marketDropdown) {
    this.marketDropdown = marketDropdown;
  }
  marketDateRangeChanged(event) {
    this.dismissIfNeeded(event.detail.endDate);
    const startDateString = event.detail.startDate;
    const endDateString = event.detail.endDate;
    const startDate = startDateString ? new Date(startDateString) : null;
    const endDate = endDateString ? new Date(endDateString) : null;
    this.args.onChange(startDate, endDate);
  }
  dismissIfNeeded(endDate) {
    if (!this.args.dismissOnSelection) {
      return;
    }
    if (this.selectionType === 'range' && !endDate) {
      return;
    }
    this.marketDropdown?.closeDropdown();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "localeTime", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "marketDropdown", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "marketDropdownInserted", [action], Object.getOwnPropertyDescriptor(_class.prototype, "marketDropdownInserted"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "marketDateRangeChanged", [action], Object.getOwnPropertyDescriptor(_class.prototype, "marketDateRangeChanged"), _class.prototype), _class);
export { MarketDateSelect as default };